import styled from "styled-components";
import { Helmet } from "react-helmet";
import { Countdown } from "../components/S3Countdown/Countdown";


const S3CountdownPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Push Portal S3</title>
        <meta property="og:title" content="Push Rewards" />
        <meta
          property="og:description"
          content="Earn rewards on Push Chain"
        />
        <meta
          property="og:image"
          content="https://portal.push.org/static/assets/previews/og-preview.webp"
        />
        <meta
          property="og:url"
          content="https://portal.push.com/rewards/controls/"
        />
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:image"
          content="https://portal.push.org/static/assets/previews/twitter-preview.webp"
        />
        <meta name="twitter:title" />
        <meta
          name="twitter:description"
          content="Earn rewards on Push Chain"
        />
      </Helmet>

      <S3CountdownPageWrapper>
        <Countdown />
      </S3CountdownPageWrapper>
    </>
  );
};

export default S3CountdownPage;

const S3CountdownPageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: DM Sans, sans-serif;
`;
